<template>
  <el-card shadow="never">
    <span slot="header" style="font-weight: 600">异常</span>
    <Content :abnormal-type="abnormalPkgSplit" abnormal="Purchase" btnTitle="登记库内异常" @submitAbnormal="purchaseCall"
      ref="check_AbnormalSubmit_Purchase" :disabledChoose="disabledChoose"/>
    <el-divider></el-divider>
    <!-- <Content :abnormal-type="abnormalClient" abnormal="Client" btnTitle="异常上报客户" @submitAbnormal="clientCall"
      ref="check_AbnormalSubmit_Client" v-if="record.purchaseType == 0" /> -->

    <AbnormalContent :abnormalOptionList="abnormalClient" checkType="popBtn" @submit="clientCall" :record="record" btnTitle="异常上报客户" />
  </el-card>
</template>

<script>
import Content from "./Content";
import AbnormalContent from "@/components/AbnormalContent.vue";
import { abnormalPkgSplit, abnormalClient } from "@/types";
import { pkgSplit,createInnerException } from "@/apis/abnormal";
import { promptCheck } from "@/apis/checking";
import { inHouseDoStockIn, getApplyCode, createSignFlow } from "@/apis/inHouse";

export default {
  name: "AbnormalSubmit",
  components: {
    Content,
    AbnormalContent
  },
  props: {
    record: {
      type: Object,
      required: true,
    },
    disabledChoose: {
      type: Boolean,
      default: false,
    },
    
  },
  data() {
    return {
      abnormalPkgSplit, // 上报采购异常
      abnormalClient, // 上报客户异常
      code: ["000000", "111111"],
    };
  },
  mounted() { },
  methods: {
    purchaseCall: function (payload) {
      let childen = this.$refs.check_AbnormalSubmit_Purchase
      if (childen.radio != 1 && childen.radio != 0) {
        this.$message.error("请选择异常类型");
        return false;
      }
      const params = {
        abnormalType: childen.radio,
        // picRelation: childen.qrCode,
        pkgCode: this.record.pkgCode,
        abnormalAmount: childen.abnormalAmount,
        remark: childen.textarea,
        picRelation: payload.qrCode,
      };
      if (params.abnormalAmount == 0 || !params.abnormalAmount) {
        this.$message.error("数量必须大于0");
        return;
      }
      if (childen.radio != '1' && params.abnormalAmount > this.record.amount) {
        this.$message.error("异常数量不能大于批次包数量");
        return;
      }
      createInnerException(params).then(({ code }) => {
        if (code === 0) {
          this.$message.success("成功");
          this.$emit('DoStockIn')
        }
      });
    },
    clientCall: async function (val) {
      const that = this
      const childen = val
      const promptCheckFlag = await promptCheck({
        pkgCode: that.record.pkgCode,
        exceptionCodeList: childen.abnormalTypeList,
        exceptionItemDtoList: childen.exceptionItemDtoList
      })
      if (promptCheckFlag.data.popup == 1) {
        that.$confirm(`批次包已上传过此异常情形，是否继续提交`, "提示", {
          confirmButtonText: "确认",
          type: "error",
          cancelButtonText: "取消",
        }).then(() => {
          continueUp()
        });
        return
      }
      continueUp()
      function continueUp(){
        let childen = val;
        const params = {
          pkgType:3,
          exceptionCodeList: childen.abnormalTypeList,
          exceptionItemDtoList: childen.exceptionItemDtoList,
          picRelation: childen.qrCode,
          pkgCode: that.record.pkgCode,
          amount: childen.num,
          remark: childen.textarea,
          exceptionSource: 1
        };
        if (params.amount == 0 || !params.amount) {
          that.$message.error("数量必须大于0");
          return;
        }
        if (params.amount > that.record.amount) {
          that.$message.error("异常数量不能大于批次包数量");
          return;
        }
        pkgSplit(params).then(({ code }) => {
          if (code === 0) {
            that.$message.success("成功");
            that.$emit('DoStockIn')
          }
        });
      }
    },
  },
};
</script>

<style scoped></style>
